const initialState = {
  books: [],
  updatingbook: {
  },
};

export default initialState;
